import React from 'react';
import { Link } from 'react-router-dom';
import ROUTERS from '../../../constants/Routers';
import './style.scss';
import { researchArticles } from '../ResearchArticle';

const ResearchOverview = () => {
  const handleExternalLink = (url, event) => {
    event.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="research-overview">
      <div className="research-overview__container">
        <div className="research-overview__header">
          <h1 className="research-overview__title">Research & Publications</h1>
          <p className="research-overview__subtitle">
            Explore the scientific foundation behind Earkick's AI-powered mental health technology. 
            Our research spans speech emotion recognition, vocal biomarkers, and AI-driven mental health assessment.
          </p>
        </div>
        
        <div className="research-overview__articles">
          {Object.entries(researchArticles).map(([key, article]) => (
            <div key={article.id} className="research-article">
              <div className="research-article__content">
                <h2 className="research-article__title">{article.title}</h2>
                <div className="research-article__meta">
                  <span className="research-article__authors">{article.authors}</span>
                  <span className="research-article__year">{article.year}</span>
                  {article.conference && (
                    <span className="research-article__venue">{article.conference}</span>
                  )}
                  {article.journal && (
                    <span className="research-article__venue">{article.journal}</span>
                  )}
                </div>
                <p className="research-article__abstract">{article.abstract}</p>
              </div>
              
              <div className="research-article__actions">
                {article.pdfUrl ? (
                  <a 
                    href={article.pdfUrl}
                    onClick={(e) => handleExternalLink(article.pdfUrl, e)}
                    className="research-article__pdf-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg className="pdf-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                    </svg>
                    Download PDF
                  </a>
                ) : (
                  <Link to={`${ROUTERS.RESEARCH}${key}`} className="research-article__read-more">
                    Read Full Article →
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResearchOverview; 